// import DocumentsComponent from '@components/documents/DocumentsComponent';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {Stack} from '@mui/material';
import {
  createAuditLog,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import React, {useEffect, useState} from 'react';
import {AI_BLOB_SEARCH, BASE_RECORD_ID} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import LegacyAppDSFilter from '../legacyApp-DS-filter/LegacyAppDSFilter';
import {useAppContext} from '@context/AppContext';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import CustomBreadcrumbs from 'src/minimal-components/custom-breadcrumbs/custom-breadcrumbs';
import AuthUtils from 'src/utils/AuthUtils';
import {
  MainContainer,
  MainDocViewContainer
} from '@components/documents/DocumentsComponentStyles';
import SingleDocViewer from '@components/docViewer/SingleDocViewer';
import FileCabinetDocumentsComponent from '@components/documents/FileCabinetDocumentsComponent';

interface FileCabinetComponentProps {
  module: string;
  menuItem: string | null;
  CustomBreadcrumbsHeading: any;
  CustomBreadcrumbsSubheading: any;
}

const FileCabinetComponent = (
  props: FileCabinetComponentProps
): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();
  // const [tabData, setTabData] = React.useState({});
  const [loader, setLoader] = React.useState(false);
  const [ParentLegacyValue, setParentLegacyValue] = useState('');
  const [selectedFolder, setSelectedFolder]: any = useState({isLoaded: false});
  const [sectionUIData, setSectionUIData]: any = React.useState(null);
  const {enqueueSnackbar} = useSnackbar();
  const [docDownloadData, setDocDownloadData] = useState<string[] | null>([]);
  const [shoulddisplaymetainfo, setShoulddisplaymetainfo] =
    useState<boolean>(false);

  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const aiBlobSearch = EncryptUtils.getDecryptedData(
    location?.search,
    AI_BLOB_SEARCH
  );
  const parsedAiBlobSearch = aiBlobSearch ? JSON.parse(aiBlobSearch) : {};
  // const {
  //   sectionUIData,
  //   handleCheckBoxClick,
  //   clearSelectedDataCount,
  //   ParentLegacyValue
  // } = props;

  const init = async () => {
    try {
      if (props.module) {
        setLoader(true);
        const res = await getSearchForm(applicationName, props.module);
        setSectionUIData({
          ...res.searchForm,
          document_folders_sql_temp: res.searchForm.document_folders_sql
        });
        setLoader(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function escapeForSQL(input: any) {
    if (typeof input !== 'string') return input;
    return `${input.replace(/'/g, "''")}`;
  }

  useEffect(() => {
    if (
      // selectedFolder?.Folder?.ID &&
      selectedFolder?.date_range &&
      Object.keys(selectedFolder?.date_range)?.length
    ) {
      // setSectionUIData((prevState: any) => {
      //   return {
      //     ...prevState,
      //     document_folders_sql:
      //       sectionUIData.document_folders_sql_temp.replaceAll(
      //         '###Folder_ID',
      //         `${selectedFolder?.Folder?.Code ? `'${selectedFolder?.Folder?.Code}'` : null}`
      //       )
      //   };
      // });
      setSelectedFolder({
        ...selectedFolder,
        isLoaded: true
      });
    }
  }, [selectedFolder?.date_range]);

  useEffect(() => {
    if (parsedAiBlobSearch?.is_ai_blob_search) {
      // Reset all states
      setShoulddisplaymetainfo(false);
      // setDocumentFolders([]);
      // setDicomFiles([]);
      // setDocData(null);
      // setCardValues([]);
      setDocDownloadData([]);
      // setIframeSrc('');
      // setIsNodeToggle(false);
    }
  }, [parsedAiBlobSearch?.is_ai_blob_search]);

  const renderParentLegacyAppFilter = () => {
    return (
      <LegacyAppDSFilter
        setParentLegacyValue={setParentLegacyValue}
        defaultLegacyAppValue={ParentLegacyValue}
        setSelectedFolder={setSelectedFolder}
        selectedFolder={selectedFolder}
        sectionUIData={sectionUIData}
        record_id={recordId}
      />
    );
  };

  const logFileCabinetData = (dataObj: any) => {
    delete dataObj.isLoaded;
    const deepEscape = (obj: any): any => {
      if (Array.isArray(obj)) {
        return obj.map(deepEscape);
      } else if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [key, deepEscape(value)])
        );
      } else {
        return escapeForSQL(obj);
      }
    };

    const escapedObj = deepEscape(dataObj);
    const keyValueString = Object.entries(escapedObj)
      .map(([key, value]) => {
        if (value) {
          return `${key}: ${JSON.stringify(escapeForSQL(value))}`;
        }
        return null;
      })
      .filter(Boolean)
      .join(', ');

    let eventDescription = props.module ? props.module + ' -> ' : '';

    if (sectionUIData?.sql_data?.audit_event_description) {
      eventDescription += `${sectionUIData?.sql_data?.audit_event_description}`;
    } else if (sectionUIData?.name) {
      eventDescription += `${sectionUIData?.name}`;
    }

    const data = {
      module: props?.module,
      sub_module: '',
      sub_module_identifier: keyValueString,
      application_name: applicationName,
      isBH_selected: true,
      isBH_reason: '',
      event_description: eventDescription,
      audit_identifier: AuthUtils.getAuditIdentifier(),
      audit_identifier_type: AuthUtils.getAuditIdentifierType(),
      audit_legacy_app: AuthUtils.getAuditLegacyApp()
    };
    createAuditLog(props.module, data);
  };

  const renderDocumentComponent = () => {
    logFileCabinetData({...selectedFolder, ParentLegacyValue});
    return (
      <FileCabinetDocumentsComponent
        subModuleUIData={sectionUIData}
        subModuleData={[]}
        module={props?.module}
        sub_module={'null'}
        patient_id={''}
        legacyApp={ParentLegacyValue}
        unique_id={''}
        ParentLegacyValue={ParentLegacyValue}
        date_range={selectedFolder?.date_range}
        // folder_id={selectedFolder?.ID}
        top={'29.5%'}
      />
    );
  };

  return (
    <div>
      {!loader && sectionUIData && Object.keys(sectionUIData).length ? (
        <Stack spacing={3} px={3}>
          <CustomBreadcrumbs
            heading={
              props.menuItem
                ? ''
                : props.module
                  ? props.CustomBreadcrumbsHeading
                  : ''
            }
            links={
              props.menuItem
                ? [
                    {
                      name: props.module ? props.CustomBreadcrumbsHeading : '',
                      href: ''
                    },
                    {
                      name: props?.menuItem
                        ? props.CustomBreadcrumbsSubheading
                        : ''
                    }
                  ]
                : []
            }
            sx={{
              mt: 2
            }}
          />
          {parsedAiBlobSearch?.is_ai_blob_search ? (
            <MainContainer height="100vh">
              {/* AI BLOB SEARCH */}
              {/* {parsedAiBlobSearch?.is_ai_blob_search ? ( */}
              <MainDocViewContainer item xs={12}>
                <SingleDocViewer
                  sectionUIData={sectionUIData?.sub_sections[0]}
                  customDocViewerActions={
                    sectionUIData?.sub_sections[0]?.actions
                  }
                  module={props?.module}
                  // sub_module={props?.sub_module}
                  refresh={true}
                  docDownloadData={docDownloadData}
                  setDocDownloadData={setDocDownloadData}
                  shoulddisplaymetainfo={shoulddisplaymetainfo}
                  setShoulddisplaymetainfo={setShoulddisplaymetainfo}
                  height={'50vh'}
                />
              </MainDocViewContainer>
              {/* ) : hideDocumentViewer ? (
                ''
              ) : (
                getDocumentViewerComponent()
              ) */}
              {/* } */}
            </MainContainer>
          ) : (
            <>
              {sectionUIData?.legacy_app_dropdown_sql ? (
                <div style={{display: 'flex'}}>
                  {renderParentLegacyAppFilter()}
                </div>
              ) : null}
              {selectedFolder?.isLoaded ? renderDocumentComponent() : null}
            </>
          )}

          {/* {renderDocumentComponent()} */}
        </Stack>
      ) : (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <LoadingScreen />
        </Stack>
      )}
    </div>
  );
};

export default FileCabinetComponent;
